// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__2dTIo","abort":"style_abort__3T3EE","submit":"style_submit__1BKl3"};